import { HelpCircle } from "lucide-react";

import {
  HoverCard,
  HoverCardTrigger,
  HoverCardContent,
} from "@/app/common/common-components/ui/HoverCard";
import { cn } from "@/app/common/common-functions/functions";
import { Link } from "@/app/common/common-components/ui/Link";
import { Button } from "@/app/common/common-components/ui/Button";

type HelpLinkIconProps = {
  className?: string;
  tooltip?: string;
  href: string;
};

export default function HelpLinkIcon({
  className,
  tooltip = "Open help file",
  href,
}: HelpLinkIconProps) {
  return (
    <HoverCard>
      <HoverCardTrigger asChild>
        <Button
          variant="ghost"
          className="tw-size-fit tw-rounded-full tw-p-2"
          asChild
        >
          <Link
            to={href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={tooltip}
            className={cn(
              "tw-inline-flex tw-size-fit tw-cursor-pointer tw-items-center tw-justify-center",
              className
            )}
          >
            <HelpCircle className="tw-min-h-4 tw-min-w-4" aria-hidden="true" />
          </Link>
        </Button>
      </HoverCardTrigger>
      <HoverCardContent className="tw-w-fit tw-px-2 tw-py-1 tw-text-xs">
        {tooltip}
      </HoverCardContent>
    </HoverCard>
  );
}
